
export const format_time = (value: number) => {
    let minutes: number = 0;
    let seconds: number = 0;
    if (value >= 60) {
      minutes = Math.floor(value / 60);
      value -= minutes * 60;
    }
    seconds = value;
    return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
  }